import React from 'react';
import ChatBotIcon from '@svg/chat-bot.svg?react';

interface ChatToggleProps {
    onClick: () => void;
}

export const ChatToggle: React.FC<ChatToggleProps> = ({onClick}) => (
    <button type="button" className="chat-toggle" aria-label="Open chat assistant" onClick={onClick}>
        <ChatBotIcon/>
    </button>
);
